module.exports = __webpack_public_path__ + "static/img/al8.372ace1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al8.jpg
// module id = bw+N
// module chunks = 1